<template>
  <navigation-button
    :route="{ name: 'MyDocuments' }"
    :style-classes="`btn-anchor ${styleClasses}`"
    text="My Documents"
    icon="file-contract"
    :display-badge="displayBadge"
    :badge-offset-x="badgeOffsetX"
    :badge-offset-y="badgeOffsetY"
    :badge-text="badge"
  />
</template>

<script>
import NavigationButton from '@/components/utils/buttons/navigation/NavigationButton';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileContract } from '@fortawesome/free-solid-svg-icons';

library.add(faFileContract);

export default {
  components: {
    NavigationButton,
  },
  props: {
    badgeOffsetX: [String, Number],
    badgeOffsetY: [String, Number],
    badgeText: [String, Number],
    styleClasses: String,
  },
  computed: {
    badge() {
      return this.badgeText || this.$store.getters.missing.documents;
    },
    displayBadge() {
      return Boolean(this.badge);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/navigation/DocumentsButton.vue